import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./skillOverview.html";
import { generateSimpleBadge } from '~/modules/helpers/badgeHelper';
import { getListingPublisher } from '~/modules/helpers/listingHelper';
import { i18nStore, WireI18n } from '~/modules/stores/i18nStore';
import { isSkillListing } from '~/modules/utilities/listing_utils';
import { getPluginDomains, getPluginReadme, getPluginSource } from '~/modules/utilities/plugin_utils';
import { buildRepositoryMarkdownUrls, getSkillDomains, getSkillMarkdownBody, getSkillPreviewImageUrl, getSkillSource } from '~/modules/utilities/skill_utils';
class SkillOverview extends LightningElement {
  constructor(...args) {
    super(...args);
    this.listing = void 0;
    this.labels = void 0;
  }
  get isSkill() {
    return isSkillListing(this.listing);
  }
  get primaryHeadingLabel() {
    const labels = i18nStore.getState().i18nStaticCache;
    return labels.listingDetails.tabs.overview;
  }
  get description() {
    // The backend truncates `description` to 255 chars; `fullDescription` carries the
    // complete text. Fall back to `description` for listings without a `fullDescription`.
    return this.listing?.fullDescription ?? this.listing?.description ?? '';
  }
  get previewImageUrl() {
    return this.isSkill ? getSkillPreviewImageUrl(this.listing) : '';
  }
  get previewImageUrls() {
    // Key by URL so a replacement image starts with fresh ax-image loading/error state.
    return this.previewImageUrl ? [this.previewImageUrl] : [];
  }
  get previewImageAlt() {
    return `${this.listing?.name ?? ''} — ${this.labels?.preview ?? ''}`;
  }
  get markdownBody() {
    return this.isSkill ? getSkillMarkdownBody(this.listing) : getPluginReadme(this.listing);
  }

  /** Render the baked-in SKILL.md or README.md when its listing payload carries one. */
  get showMarkdown() {
    return !!this.markdownBody;
  }
  get source() {
    return this.isSkill ? getSkillSource(this.listing) : getPluginSource(this.listing);
  }
  get markdownRepositoryUrls() {
    return buildRepositoryMarkdownUrls(this.source, this.source?.path ?? '');
  }
  get markdownLinkBaseUrl() {
    return this.markdownRepositoryUrls.linkBaseUrl;
  }
  get markdownImageBaseUrl() {
    return this.markdownRepositoryUrls.imageBaseUrl;
  }
  get markdownAllowedImageRootUrls() {
    return this.markdownRepositoryUrls.allowedImageRootUrls;
  }
  get categoriesLabel() {
    return this.labels?.categories ?? '';
  }
  get domainsLabel() {
    return this.labels?.domainsLabel ?? '';
  }

  // Skills and plugins both carry their canonical domain categorization in extension data.
  get domainBadges() {
    const labels = this.labels?.domains ?? {};
    const domains = this.isSkill ? getSkillDomains(this.listing) : getPluginDomains(this.listing);
    return domains.map(domain => generateSimpleBadge(labels[domain] || domain));
  }
  get hasDomainBadges() {
    return this.domainBadges.length > 0;
  }
  get provider() {
    return getListingPublisher(this.listing);
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(SkillOverview, {
  publicProps: {
    listing: {
      config: 0
    }
  },
  wire: {
    labels: {
      adapter: WireI18n,
      dynamic: [],
      config: function ($cmp) {
        return {
          selector: i18n => i18n.skills
        };
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(SkillOverview, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;